import teams from "../data/teams.json";

const logoBySlug = {
  okc: "/TeamLogo/OKC.png",
  lakers: "/TeamLogo/Lakers.png",
  knicks: "/TeamLogo/Knicks.png",
  cavaliers: "/TeamLogo/Cavaliers.png",
  timberwolves: "/TeamLogo/Timberwolves.png",
};

const extrasBySlug = {
  okc: {
    bgColor: "#01315f",
    accentColor: "#babdc0",
    avatars: [
      "/PlayerAvatars/OKC/Shai Gilgeous-Alexander.png",
      "/PlayerAvatars/OKC/chet-holmgren-okc-portrait.png",
      "/PlayerAvatars/OKC/aaron-wiggins-okc-portrait.png",
      "/PlayerAvatars/OKC/isaiah-hartenstein-okc-portrait.png",
      "/PlayerAvatars/OKC/luguentz-dort-okc-portrait.png",
      "/PlayerAvatars/OKC/jalen-williams-okc-portrait.png",
      "/PlayerAvatars/OKC/jaylin-williams-okc-portrait.png",
      "/PlayerAvatars/OKC/ajay-mitchell-okc-portrait.png",
      "/PlayerAvatars/OKC/alex-caruso-okc-portrait.png",
    ],
  },
  lakers: {
    bgColor: "#4f257d",
    accentColor: "#FDB927",
    avatars: [
      "/PlayerAvatars/Lakers/lebron-james-lakers-portrait.png",
      "/PlayerAvatars/Lakers/luka-doncic-lakers-portrait.png",
      "/PlayerAvatars/Lakers/rui-hachimura-lakers-portrait.png",
      "/PlayerAvatars/Lakers/austin-reaves-lakers-portrait.png",
      "/PlayerAvatars/Lakers/deandre-ayton-lakers-portrait.png",
      "/PlayerAvatars/Lakers/jarred-vanderbilt-lakers-portrait.png",
      "/PlayerAvatars/Lakers/dalton-knecht-lakers-portrait.png",
      "/PlayerAvatars/Lakers/maxi-kleber-lakers-portrait.png",
      "/PlayerAvatars/Lakers/jaxson-hayes-lakers-portrait.png",
    ],
  },
  knicks: {
    bgColor: "#02419a",
    accentColor: "#F58426",
    avatars: [
      "/PlayerAvatars/Knicks/jalen-brunson-knicks-portrait.png",
      "/PlayerAvatars/Knicks/karl-anthony-towns-knicks-portrait.png",
      "/PlayerAvatars/Knicks/og-anunoby-knicks-portrait.png",
      "/PlayerAvatars/Knicks/mikal-bridges-knicks-portrait.png",
      "/PlayerAvatars/Knicks/miles-mcbride-knicks-portrait.png",
      "/PlayerAvatars/Knicks/josh-hart-knicks-portrait.png",
      "/PlayerAvatars/Knicks/mitchell-robinson-knicks-portrait.png",
      "/PlayerAvatars/Knicks/jordan-clarkson-knicks-portrait.png",
      "/PlayerAvatars/Knicks/landry-shamet-knicks-portrait.png",
    ],
  },
  cavaliers: {
    bgColor: "#4b0b20",
    accentColor: "#f4c96b",
    avatars: [
      "/PlayerAvatars/Cavaliers/donovan-mitchell-cavaliers-portrait.png",
      "/PlayerAvatars/Cavaliers/jarrett-allen-cavaliers-portrait.png",
      "/PlayerAvatars/Cavaliers/max-strus-cavaliers-portrait.png",
      "/PlayerAvatars/Cavaliers/evan-mobley-cavaliers-portrait.png",
      "/PlayerAvatars/Cavaliers/james-harden-cavaliers-portrait.png",
      "/PlayerAvatars/Cavaliers/dennis-schroder-cavaliers-portrait.png",
      "/PlayerAvatars/Cavaliers/lonzo-ball-cavaliers-portrait.png",
      "/PlayerAvatars/Cavaliers/thomas-bryant-cavaliers-portrait.png",
      "/PlayerAvatars/Cavaliers/craig-porter-jr-cavaliers-portrait.png",
    ],
  },
  timberwolves: {
    bgColor: "#052c51",
    accentColor: "#78BE20",
    avatars: [
      "/PlayerAvatars/Timberwolves/anthony-edwards-timberwolves-portrait.png",
      "/PlayerAvatars/Timberwolves/Julius Randle.png",
      "/PlayerAvatars/Timberwolves/donte-divincenzo-timberwolves-portrait.png",
      "/PlayerAvatars/Timberwolves/Rudy Gobert.png",
      "/PlayerAvatars/Timberwolves/naz-reid-timberwolves-portrait.png",
      "/PlayerAvatars/Timberwolves/jaden-mcdaniels-timberwolves-portrait.png",
      "/PlayerAvatars/Timberwolves/bones-hyland-timberwolves-portrait.png",
      "/PlayerAvatars/Timberwolves/jaylen-clark-timberwolves-portrait.png",
      "/PlayerAvatars/Timberwolves/mike-conley-timberwolves-portrait.png",
    ],
  },
};

export const TEAM_LIST = teams.map((t) => ({
  ...t,
  logo: logoBySlug[t.slug],
  bgColor: extrasBySlug[t.slug]?.bgColor ?? "#1a1a2e",
  accentColor: extrasBySlug[t.slug]?.accentColor ?? "#ffffff",
  avatars: extrasBySlug[t.slug]?.avatars ?? [],
}));
